import React, { useState } from 'react';
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import tokenService from '../services/tokenService';
import { canLicenseCourses } from './marketplaceVisibility';
import StorefrontConfigForm from '../components/Storefront/Admin/StorefrontConfigForm';
import StorefrontProductsPanel from '../components/Storefront/Admin/StorefrontProductsPanel';
import EmbedTokensPanel from '../components/Storefront/Embeds/EmbedTokensPanel';
import MaterialSymbol from '../components/common/MaterialSymbol';

/**
 * Storefront-Verwaltung (T7, Plan 3.3/3.8), ersetzt die Landing-Pages-Seite.
 * Einstellungen: Company-Admin (wie `PUT /api/storefront/config`); Produkte:
 * Content-Manager. Der Zugang insgesamt hängt am Recht `storefront.manage`.
 */
const StorefrontAdminPage: React.FC = () => {
    const translate = useTranslate();
    const isAdmin = canLicenseCourses(tokenService.getRoles());
    const [tab, setTab] = useState<'settings' | 'products' | 'embeds'>(isAdmin ? 'settings' : 'products');
    const [store, setStore] = useState<{ slug: string; enabled: boolean } | null>(null);

    return (
        <Box>
            <h1 className="oa-page-title">{translate('storefront.admin.title')}</h1>
            <Typography color="text.secondary" sx={{ mb: 2 }}>{translate('storefront.admin.intro')}</Typography>

            {store?.enabled ? (
                <Button
                    href={`/store/${store.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<MaterialSymbol name="open_in_new" />}
                    sx={{ mb: 2 }}
                >
                    {translate('storefront.admin.openStore')}: /store/{store.slug}
                </Button>
            ) : null}

            <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3, borderBottom: '1px solid var(--oa-divider)' }} aria-label={translate('storefront.admin.title')}>
                {isAdmin ? <Tab value="settings" label={translate('storefront.admin.tabs.settings')} /> : null}
                <Tab value="products" label={translate('storefront.admin.tabs.products')} />
                {isAdmin ? <Tab value="embeds" label={translate('storefront.admin.tabs.embeds')} /> : null}
            </Tabs>

            {tab === 'settings' && isAdmin ? <StorefrontConfigForm onSaved={(slug, enabled) => setStore({ slug, enabled })} /> : null}
            {tab === 'products' ? <StorefrontProductsPanel /> : null}
            {tab === 'embeds' && isAdmin ? <EmbedTokensPanel /> : null}
        </Box>
    );
};

export default StorefrontAdminPage;
